import type { ClickableItem, IsDropdownItem, VisibleItem } from 'layouts/main/sp-header/navigation/models';
import { NavigationItem } from 'layouts/main/sp-header/navigation/NavigationItem';
import { connect } from 'react-redux';
import { isDiscoverPageVisible, isUnderlyingUniverseVisible } from 'state/selectors/common/router';
import type { AppState } from 'state/state.model';

function InsightsItem({ isDropdownItem, isVisible, onClick }: IsDropdownItem & VisibleItem & ClickableItem) {
  return (
    <NavigationItem
      targetRoute="/home"
      label="appHeader.navigation.explore.insights"
      dataE2eSuffix="welcome-page"
      category="Workspace"
      action="Discover"
      isVisible={isVisible}
      isDropdownItem={isDropdownItem}
      onClick={onClick}
    />
  );
}
export const ConnectedInsightsItem = connect((state: AppState) => ({
  isVisible: isDiscoverPageVisible(state),
}))(InsightsItem);

export function UnderlyingUniverseItem({
  isDropdownItem,
  onClick,
  isVisible,
}: IsDropdownItem & ClickableItem & VisibleItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/underlying-universe"
      label="appHeader.navigation.explore.underlyingUniverse"
      dataE2eSuffix="underlying"
      category="Workspace"
      isDropdownItem={isDropdownItem}
      action="Underlying universe"
      onClick={onClick}
    />
  );
}

export const ConnectedUnderlyingUniverseItem = connect((state: AppState) => ({
  isVisible: isUnderlyingUniverseVisible(state),
}))(UnderlyingUniverseItem);
